import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_TITLE } from '@/hooks/useDocumentTitle';

interface DocumentTitleProviderProps {
  children: React.ReactNode;
}

/**
 * A component that sets the default document title for the app
 * and resets it when navigating to pages that don't explicitly set a title
 */
const DocumentTitleProvider: React.FC<DocumentTitleProviderProps> = ({ children }) => {
  const location = useLocation();
  
  // Set the default title when the location changes
  // This will be overridden by specific pages that set their own title
  useEffect(() => {
    // Pages that set their own title:
    // - /settings (UserSettings.tsx)
    // - /business/:businessId (BusinessDashboard.tsx)
    
    // We don't need to set the title here for those pages
    // as they will set their own title using the useDocumentTitle hook
    
    // For all other pages, set the default title
    const isUserSettingsPage = location.pathname === '/settings';
    const isBusinessDashboardPage = /^\/business\/[^/]+$/.test(location.pathname);
    
    if (!isUserSettingsPage && !isBusinessDashboardPage) {
      document.title = DEFAULT_TITLE;
    }
  }, [location]);
  
  return <>{children}</>;
};

export default DocumentTitleProvider;
